import { ensureSyntaxTree } from "@codemirror/language";

const HUNDRED_MS = 100;
const SEARCH_FORWARD_LIMIT = 6000;

export const commentIsOpenFold = (node, state) => {
    const content = state.doc.sliceString(node.from, node.to);
    return Boolean(content.match(/%\s*\{\s*/));
};

export const commentIsCloseFold = (node, state) => {
    const content = state.doc.sliceString(node.from, node.to);
    return Boolean(content.match(/%\s*\}\s*/));
};

export const findClosingFoldComment = (node, state) => {
    const start = node.to + 1;
    const upto = Math.min(start + SEARCH_FORWARD_LIMIT, state.doc.length);
    const tree = ensureSyntaxTree(state, upto, HUNDRED_MS);
    if (!tree) {
        return undefined;
    }

    let closingFoldNode;
    let nestingLevel = 0;

    tree.iterate({
        from: start,
        to: upto,
        enter(entry) {
            if (closingFoldNode) {
                return false;
            }

            if (entry.node.type.is("Comment")) {
                if (commentIsOpenFold(entry.node, state)) {
                    nestingLevel += 1;
                } else if (commentIsCloseFold(entry.node, state)) {
                    if (nestingLevel > 0) {
                        nestingLevel -= 1;
                    } else {
                        closingFoldNode = entry.node;
                        return false;
                    }
                }
            }

            return undefined;
        },
    });

    return closingFoldNode;
};

export const getFoldRange = (startNode, endNode, state) => {
    const startContent = state.doc.sliceString(startNode.from, startNode.to);
    const endContent = state.doc.sliceString(endNode.from, endNode.to);

    const openBracePos = startContent.indexOf("{");
    const closeBracePos = endContent.indexOf("}");
    if (openBracePos < 0 || closeBracePos < 0) {
        return null;
    }

    return {
        from: startNode.from + openBracePos + 1,
        to: endNode.from + closeBracePos,
    };
};
